<!-- Created by Arga Ghulam Ahmad - arga@jojonomic.com -->
<template>
  <b-col :cols="gridCols">
    <div class="jSingleFileUploader">
      <!--Image preview card-->
      <div>
        <label for="icon"> {{ labelName }} </label>
        <b-card
          v-if="thumbnail"
          :class="determineThumbnail"
          :img-src="thumbnail"
          overlay
          @click="clickedPreviewCard">
          <i
            v-if="(thumbnail || imgDefault) && !disabled"
            class="fa fa-close fa__delete-icon"
            @click="deleteFile"/>
        </b-card>
        <b-card
          v-else
          :class="determineThumbnail"
          :img-src="imgDefaultThumbnail"
          overlay
          @click="clickedPreviewCard">
          <i
            v-if="(thumbnail || imgDefault) && !disabled"
            class="fa fa-close fa__delete-icon"
            @click="deleteFile"/>
          <img
            v-if="!imgDefaultThumbnail"
            :src="require('@/assets/icon/no-file.png')">
        </b-card>
      </div>

      <!--Image chooser form-->
      <b-form-file
        ref="fileinput"
        v-model="file"
        plain/>
      <div
        v-if="!disabled"
        class="btn-upload-oos"
        @click="clickBrowseButton">
        {{ label }}
      </div>
      <div class="label-upload-oos">
        Extension: jpg, png, jpeg, bmp
        Maximum file upload: 5 MB
      </div>
      <!--Error Screen-->
      <jProblemScreen
        ref="problemScreen"
        :message="error_message"/>
      <!--Loading Screen-->
      <jLoadingScreen ref="loadingScreen"/>
      <!--Success Screen-->
      <jSuccessScreen
        ref="successScreen"
        :message="'File has been successfully uploaded'"/>
      <!--Image preview modal-->
      <b-modal
        ref="imageModal"
        :ok-only="true"
        :hide-header="true"
        :hide-footer="true"
        :centered="true">
        <div v-if="thumbnail">
          <img :src="thumbnail">
        </div>
        <div v-else>
          <img :src="imgDefaultThumbnail">
        </div>
      </b-modal>
    </div>
  </b-col>
</template>

<script>
/* eslint-disable max-len, no-unused-vars,import/no-unresolved,vue/require-default-prop,global-require */
import { mapActions } from 'vuex';
import { jSingleFileUploaderMixins } from './jSingleFileUploaderMixins';
import { jUploaderMixins } from './jUploaderMixins';
import jProblemScreen from '../notification-screen/jProblemScreen';
import jLoadingScreen from '../notification-screen/jLoadingScreen';
import jSuccessScreen from '../notification-screen/jSuccessScreen';

export default {
  name: 'JUpload',
  components: {
    jProblemScreen, jLoadingScreen, jSuccessScreen,
  },
  mixins: [jSingleFileUploaderMixins, jUploaderMixins],
  /**
         * acceptedFileType: array represent accepted file type
         */
  props: {
    acceptedFileType: {
      type: Array,
      default: () => ([]),
    },
    label: {
      type: String,
      default: 'Browse',
    },
    imgDefault: {
      type: String,
      default: null,
    },
    apiToken: {
      type: String,
      default: '',
    },
    urlUpload: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    gridCols: {
      type: Number,
      default: 1,
    },
    labelName: {
      type: String,
      default: 'Label',
    },
  },
  /**
         * file: current uploaded file object
         * fileName: current file name
         * thumbnail: current file img thumbnail
         * fileUrl: download url for the file
         * fileType: current file type
         * isImageShow: is image modal show?
         */
  data() {
    return {
      file: null,
      fileName: '',
      thumbnail: null,
      fileUrl: this.imgDefault ? this.imgDefault : '',
      fileType: '',
      isImageShow: false,
      error_message: '',
    };
  },
  computed: {
    /**
             * determine thumbnail
             * @returns {string} class used on preview card
             */
    determineThumbnail() {
      if (this.file === null && !this.imgDefault) {
        return 'oos-card-no-file';
      }
      return 'oos-card-file';
    },
    imgDefaultThumbnail() {
      if (this.imgDefault) {
        const fileName = this.imgDefault;
        const dotPosition = fileName.lastIndexOf('.') + 1;
        let extension = fileName.substring(dotPosition);
        extension = extension.toLowerCase();
        const thumbnail = this.determineThumbnails(extension);
        if (thumbnail === '') {
          return this.imgDefault;
        }
        return thumbnail;
      }
      return this.imgDefault;
    },
  },
  watch: {
    /**
             * watch uploaded file, is the file accepted?
             */
    fileUrl() {
      this.$emit('url', this.fileUrl);
    },
    file() {
      if (this.file !== null && this.file !== undefined) {
        const fileName = this.file.name;
        const dotPosition = fileName.lastIndexOf('.') + 1;
        let extension = fileName.substring(dotPosition);
        extension = extension.toLowerCase();
        this.fileType = extension;

        let isAccepted = false;
        this.acceptedFileType.forEach((type) => {
          if (type === extension) {
            isAccepted = true;
          }
        });

        if (isAccepted) {
          this.uploadFile(this.file, extension);
          this.fileName = fileName;
        } else {
          this.error_message = 'Please choose a wanted file!';
          this.clearFiles();
          // this.$refs.problemScreen.toggleProblemScreen();
          this.toggleProblem(this.error_message);
        }
      }
    },
    /**
             * preview card toggle mechanism
             */
    isImageShow() {
      if (this.isImageShow) {
        this.showImageModal();
      } else {
        this.hideImageModal();
      }
    },
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'toggleSuccess']),
    /**
             * reset inputted file on input form
             */
    clearFiles() {
      this.fileUrl = '';
      this.$refs.fileinput.reset();
    },

    determineThumbnails(extension) {
      const pdfThumbnail = require('./pdf.svg');
      const docThumbnail = require('./doc.svg');
      const xlsThumbnail = require('./xls.svg');
      const csvThumbnail = require('./csv.svg');
      const txtThumbnail = require('./txt.svg');

      if (extension === 'pdf') {
        return pdfThumbnail;
      } if (extension === 'doc' || extension === 'docx' || extension === 'ppt' || extension === 'pptx') {
        return docThumbnail;
      } if (extension === 'xls' || extension === 'xlsx') {
        return xlsThumbnail;
      } if (extension === 'csv') {
        return csvThumbnail;
      } if (extension === 'txt') {
        return txtThumbnail;
      }
      return '';
    },
    /**
             * delete current file
             */
    deleteFile() {
      this.file = null;
      this.fileName = '';
      this.thumbnail = '';
      this.fileUrl = '';
      this.fileType = '';
      this.imgDefault = null;
      this.clearFiles();
    },
    /**
             * show image preview modal
             */
    showImageModal() {
      this.$refs.imageModal.show();
    },
    /**
             * hide image preview modal
             */
    hideImageModal() {
      this.$refs.imageModal.hide();
      this.clickedPreviewCard();
    },
    /**
     * clicked preview card
     *
     * if the file is an image, card will display img preview
     * if the file is not an image, program will create new tab
     *      and ask user to download the file
     */
    clickedPreviewCard() {
      if (this.file !== null) {
        if (this.fileType === 'jpg' || this.fileType === 'png' || this.fileType === 'jpeg' || this.fileType === 'bmp') {
          this.isImageShow = !this.isImageShow;
        } else {
          window.open(this.fileUrl, '_blank');
        }
      } else if (this.imgDefault !== null) {
        const dotPosition = this.imgDefault.lastIndexOf('.') + 1;
        let extension = this.imgDefault.substring(dotPosition);
        extension = extension.toLowerCase();

        if (extension === 'jpg' || extension === 'png' || extension === 'jpeg' || extension === 'bmp') {
          this.isImageShow = !this.isImageShow;
        } else {
          window.open(this.imgDefault, '_blank');
        }
      }
    },
    /**
       * click browse button method
       */
    clickBrowseButton() {
      this.$refs.fileinput.$refs.input.click();
    },
    /**
       * do this code, when upload process is fail
       */
    uploadFailed() {
      this.file = null;
      this.fileUrl = '';
    },
    /**
       * do this code, when upload process is success
       * @param thumbnail file's thumbnail
       * @param fileUrl file's download url
       */
    uploadSuccess(thumbnail, fileUrl) {
      this.thumbnail = thumbnail;
      this.fileUrl = fileUrl;
    },
  },
};
</script>

<style lang="scss">
  .btn-upload {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 70%;
    max-width: 150px;
    margin-top: 10px;
    border-radius: 20px !important;
  }

  .oos-card-no-file {
    height: 120px;
    position: relative;
    background: #FFFFFF;
    border: 1px dashed #CDCDCD !important;
    border-radius: 3px;
  }

  .btn-upload-oos {
    background: #FFFFFF;
    border: 1px solid #E3E3E3;
    border-radius: 4px;
    cursor: pointer;
    width: 100%;
    color: #1A85E4;
    margin-top: 7px;
    text-align: center;
    padding: 3px;
    font-size: 14px;
    font-family: 'Poppins-Medium';
  }

  .label-upload-oos {
    font-size: 9px;
    margin-top: 3px;
    color: #95989A;
  }

  .card-img-overlay {
    text-align: center;

    img {
      height: 80px !important;
      width: 25px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/file-uploader/jUpload.vue